import AdSlot from "./AdSlot.jsx";
import AppFooter from "./AppFooter.jsx";
import LanguageToggle from "./LanguageToggle.jsx";
import PlusNudge from "./PlusNudge.jsx";
import { levels, tools } from "../data/appCatalog.js";
import { useI18n } from "../i18n.jsx";
import { assetPath } from "../lib/legacyPaths.js";

export default function AppShell({ level, toolId, children, navigate }) {
  const { t } = useI18n();
  const tool = toolId ? tools[toolId] : null;
  const levelLabel = t(level.nameKey, {}, level.label);
  const toolTitle = tool ? t(tool.titleKey, {}, tool.title) : "";
  const shellStyle = {
    "--level-color": level.color,
    "--level-accent": level.accent,
    "--level-bg": level.background,
    "--tool-accent": tool?.accent || level.accent,
    "--tool-accent-strong": tool?.accentStrong || level.accent,
    "--tool-soft": tool?.soft || "#f8fafc",
    "--tool-surface": tool?.surface || "#fff",
    "--tool-ring": tool?.ring || "rgba(15, 23, 42, .12)"
  };

  return (
    <div className="app-shell" style={shellStyle}>
      <header className="topbar">
        <button className="icon-button" type="button" onClick={() => navigate(`/${level.id}`)} aria-label={t("shell.backToLevel")}>
          {t("common.back")}
        </button>
        <button className="icon-button" type="button" onClick={() => navigate("/")} aria-label={t("common.home")}>
          {t("common.home")}
        </button>
        <nav className="level-switcher" aria-label={t("shell.switchLevel")}>
          {levels.map((item) => (
            <button
              className={item.id === level.id ? "level-link is-active" : "level-link"}
              key={item.id}
              type="button"
              onClick={() => navigate(toolId && item.tools.includes(toolId) ? `/${item.id}/${toolId}` : `/${item.id}`)}
            >
              {t(item.nameKey, {}, item.label)}
            </button>
          ))}
        </nav>
        <a className="publisher-link" href="https://sielpabooks.com/" target="_blank" rel="noreferrer">
          {t("shell.publisher")}
        </a>
        <LanguageToggle className="topbar-language-toggle" />
        <PlusNudge className="topbar-plus-link" source="topbar-plus" showWhenPlus>
          SielpA Plus
        </PlusNudge>
      </header>

      <main className="app-main">
        <section className="page-title">
          <img src={assetPath(level.badge)} alt={t("shell.levelBadge", { level: levelLabel })} />
          <div>
            <p className="kicker">{t(level.toolsLabelKey, {}, level.toolsLabel)}</p>
            <h1>{tool ? toolTitle : t("shell.levelTitle", { level: levelLabel })}</h1>
            <p>{tool ? t(tool.subtitleKey, {}, tool.subtitle) : t(level.descriptionKey, {}, level.description)}</p>
          </div>
        </section>
        <AdSlot position="top" />
        {children}
        <AdSlot position="bottom" />
      </main>
      <AppFooter />
    </div>
  );
}
